module.exports = __webpack_public_path__ + "static/media/user-circle-regular.5b7265ba.svg";